import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNoMakeupGlyphSecondary from './svgs/NoMakeupGlyphSecondary.js';
import SvgNoMakeupGlyph from './svgs/NoMakeupGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var noMakeupGlyph = (props => useIcon(SvgNoMakeupGlyph, SvgNoMakeupGlyphSecondary, props));

export { noMakeupGlyph as default };
